module.exports = __webpack_public_path__ + "static/media/bestpreis_v2.29247e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/bestpreis_v2.png
// module id = 588
// module chunks = 0